//WE.Flow.Html.Contracts.Manifests.ProductConfig

export class ProductConfig {
    name: string = "";
    description: string = "";
    impersonation: string = "";
    payload: string = "";
    hideChange: boolean = false;
}
